<template>
	<div id="app">
		<router-view v-slot="{ Component }">
			<component :is="Component" />
		</router-view>
	</div>
</template>

<script setup>
</script>

<style>
#app {
	height: 100%;
}
</style>

